import { useEffect } from 'react';
import { useCountriesOperations } from './useCountriesOperations';
import { useIsAutorizedUser } from 'store/features/auth';

export const useInitAvoidedCountries = () => {
  const { getAvoidedCountries } = useCountriesOperations();
  const isAutorizedUser = useIsAutorizedUser();

  useEffect(() => {
    if (isAutorizedUser) {
      getAvoidedCountries();
    }
  }, [
    isAutorizedUser,
    getAvoidedCountries
  ]);
};
